<template>
    <div class="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
      <div class="w-full max-w-md bg-white dark:bg-slate-800 rounded-xl shadow p-6">
        <h1 class="text-2xl font-semibold mb-6 text-gray-900 dark:text-gray-100">Criar conta</h1>
  
        <form @submit.prevent="register" class="space-y-4">
          <div>
            <label class="block text-sm mb-1 text-gray-700 dark:text-gray-100">Nome</label>
            <input v-model.trim="name" type="text" required
                   class="w-full px-3 py-2 border rounded-md dark:bg-slate-800 dark:border-slate-700 dark:text-gray-100"/>
          </div>
  
          <div>
            <label class="block text-sm mb-1 text-gray-700 dark:text-gray-100">E-mail</label>
            <input v-model.trim="email" type="email" required
                   class="w-full px-3 py-2 border rounded-md dark:bg-slate-800 dark:border-slate-700 dark:text-gray-100"/>
          </div>
  
          <!-- Gerência (novo) -->
          <div>
            <label class="block text-sm mb-1 text-gray-700 dark:text-gray-100">Gerência</label>
            <select v-model="unit" required
                    class="w-full px-3 py-2 border rounded-md bg-white dark:bg-slate-800 dark:border-slate-700 dark:text-gray-100">
              <option disabled value="">Selecione…</option>
              <option v-for="g in managementOptions" :key="g" :value="g">{{ g }}</option>
            </select>
          </div>
  
          <div>
            <label class="block text-sm mb-1 text-gray-700 dark:text-gray-100">Senha</label>
            <input v-model="password" type="password" minlength="6" required
                   class="w-full px-3 py-2 border rounded-md dark:bg-slate-800 dark:border-slate-700 dark:text-gray-100"/>
          </div>
  
          <div>
            <label class="block text-sm mb-1 text-gray-700 dark:text-gray-100">Confirmar senha</label>
            <input v-model="password2" type="password" minlength="6" required
                   class="w-full px-3 py-2 border rounded-md dark:bg-slate-800 dark:border-slate-700 dark:text-gray-100"/>
          </div>
  
          <fwb-button gradient="green-blue" outline class="w-full py-2" :disabled="loading">
            {{ loading ? 'Criando…' : 'Registrar' }}
          </fwb-button>
        </form>
  
        <p v-if="error" class="mt-4 text-sm text-red-500">{{ error }}</p>
        <p class="mt-4 text-sm text-gray-700 dark:text-gray-100">
          Já tem conta?
          <router-link to="/login" class="text-emerald-500 hover:underline">Entrar</router-link>
        </p>
      </div>
    </div>
  </template>
  
  <script>
  import axios from 'axios'
  import { FwbButton } from 'flowbite-vue'
  
  export default {
    name: 'RegisterMain',
    components: { FwbButton },
    data() {
      return {
        name: '', email: '', unit: '',
        password: '', password2: '',
        loading: false, error: '', apiBase: '/api',

        managementOptions: [
          'GEOF',
          'GPI',
          'GEAAL',
          'SGI',
          'GESTD',
          'GGDP',
          'GCGC',
          'GECONT',
          'GEINFRA'
        ]
      }
    },
    methods: {
      async register() {
        this.error = ''
        if (!this.unit) {
          this.error = 'Selecione a gerência.'
          return
        }
        if (this.password !== this.password2) {
          this.error = 'As senhas não conferem.'
          return
        }
        this.loading = true
        try {
          await axios.post(`${this.apiBase}/auth/register`, {
            name: this.name,
            email: this.email,
            password: this.password,
            unit: this.unit
          })
  
          const { data } = await axios.post(`${this.apiBase}/auth/login`, {
            email: this.email, password: this.password
          })
          localStorage.setItem('token', data.access_token)
          localStorage.setItem('user', JSON.stringify({ ...data.user, unit: this.unit }))
          axios.defaults.headers.common['Authorization'] = `Bearer ${data.access_token}`
  
          const redirect = this.$route.query.redirect || '/'
          this.$router.replace(redirect)
        } catch (e) {
          this.error = e?.response?.data?.error || 'Não foi possível registrar.'
          console.error(e)
        } finally {
          this.loading = false
        }
      }
    }
  }
  </script>
  